import { marked } from 'marked'
import DOMPurify from 'dompurify'

marked.use({
  gfm: true,
  breaks: true
})

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'u', 'del', 's',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'blockquote', 'code', 'pre', 'hr',
  'a', 'img',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'span', 'div'
]

const ALLOWED_ATTR = ['href', 'title', 'src', 'alt', 'class', 'colspan', 'rowspan', 'align']

function sanitizeHref(node, data) {
  if (data.attrName !== 'href') return
  const v = (data.attrValue || '').trim()
  const ok = /^https?:\/\//i.test(v) || /^mailto:/i.test(v)
  if (!ok) data.keepAttr = false
}

function sanitizeSrc(node, data) {
  if (data.attrName !== 'src') return
  const v = (data.attrValue || '').trim()
  if (!/^https?:\/\//i.test(v) && !/^data:image\/(png|jpeg|gif|webp);base64,/i.test(v)) {
    data.keepAttr = false
  }
}

let hooksInstalled = false

function ensureHooks() {
  if (hooksInstalled || typeof DOMPurify.addHook !== 'function') return
  hooksInstalled = true
  DOMPurify.addHook('uponSanitizeAttribute', sanitizeHref)
  DOMPurify.addHook('uponSanitizeAttribute', sanitizeSrc)
}

/**
 * Markdown (GFM, tabelas) → HTML sanitizado para uso em v-html.
 */
export function renderChatMarkdown(markdown) {
  const src = markdown == null ? '' : String(markdown)
  if (!src.trim()) return ''

  let html
  try {
    html = marked.parse(src)
  } catch {
    return DOMPurify.sanitize(`<pre class="chat-md-fallback">${escapeForPre(src)}</pre>`, {
      ALLOWED_TAGS: ['pre'],
      ALLOWED_ATTR: ['class']
    })
  }

  ensureHooks()
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false
  })
}

function escapeForPre(s) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}
